import React, {useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';

import {AuthModal} from "../AuthModal";
import {SignUpData, SignUpFirstStep} from "./elements/SignUpFirstStep";
import {SignUpConfirmStep} from "./elements/SignUpConfirmStep";
import {getInviteInfoFromLink} from "../../../../../actions/invite";


import {SignUpByLink} from '../SignUpByLink';

export const SignUp = observer(() => {
    const [isBackVisible, setShowBack] = useState(false);
    const [step, setStep] = useState(1);
    const [stepData, setStepData] = useState<SignUpData | undefined>(undefined);

    const handleClose = useCallback(() => {}, []);

    const renderStep = () => {
        switch (step) {
            case 2:
                return <SignUpConfirmStep setStep={setStep} stepData={stepData} setShowBack={setShowBack}/>;
            default:
            case 1:
                return <SignUpFirstStep/>
        }
    }

    const inviteInfo = getInviteInfoFromLink();

    if (inviteInfo) {
        return (
            <SignUpByLink />
        );
    } else {
        return (
            <AuthModal
                isOpen={true}
                onClose={handleClose}
                isBackVisible={isBackVisible}
            >
                {renderStep()}
            </AuthModal>
        );
    }
})
